function beforeLinkLoadListener(evt) {
    // Prevent the CSS from loading immediately
    if (evt.target.getAttribute('data-deferred') === 'true') {
        evt.preventDefault();
    }
}

(function () {
    try {
        var head = document.getElementsByTagName('head');
        if (!head) return;
        var targetNode = head[0];
        if (!targetNode) return;
        var config = { attributes: true, childList: true, subtree: false };

        // Define CSS patterns to defer (non-critical CSS)
        var deferredCSSPatterns = [
            /freeGiftLogicv1\.css/,
            /reviews\.css/,
            /quantity-breaks\.css/,
        ];

        // Function to defer CSS loading
        function deferCSS(linkElement) {
            // Store original href
            var originalHref = linkElement.href;

            // Mark as deferred
            linkElement.setAttribute('data-deferred', 'true');
            linkElement.setAttribute('data-original-href', originalHref);

            // Set media to prevent immediate loading
            linkElement.media = 'print';
            linkElement.onload = null; // Clear any existing onload

            // Load the CSS after a delay to not block critical rendering
            setTimeout(function () {
                linkElement.media = 'all';
                linkElement.removeAttribute('data-deferred');
            }, 100); // Small delay to let critical CSS load first
        }

        var callback = (mutationList, observer) => {
            for (var mutation of mutationList) {
                if (mutation.type === 'childList') {
                    for (var addedNode of mutation.addedNodes) {
                        // Handle CSS link tags
                        if (
                            addedNode.nodeType === 1 &&
                            addedNode.tagName === 'LINK' &&
                            addedNode.rel === 'stylesheet' &&
                            !addedNode.classList.contains('critical-css') &&
                            addedNode.href
                        ) {
                            var href = addedNode.href;
                            var isDeferredCSS = deferredCSSPatterns.some(
                                (pattern) => pattern.test(href),
                            );

                            if (isDeferredCSS) {
                                console.log('Deferring CSS:', href);
                                deferCSS(addedNode);
                            }
                        }

                        // Handle style tags with specific content (inline app styles)
                        if (
                            addedNode.nodeType === 1 &&
                            addedNode.tagName === 'STYLE' &&
                            !addedNode.classList.contains('critical-css') &&
                            addedNode.textContent
                        ) {
                            var content = addedNode.textContent;
                            var isAppStyle =
                                content.includes('.globo-') ||
                                content.includes('.influence-') ||
                                content.includes('.reviews-') ||
                                content.includes('/* App:') ||
                                content.includes('[data-app=');

                            if (isAppStyle) {
                                console.log('Deferring inline style block');
                                // For inline styles, we wrap in a setTimeout
                                var originalContent = addedNode.textContent;
                                addedNode.textContent = '/* Deferred */';

                                setTimeout(function () {
                                    addedNode.textContent = originalContent;
                                }, 150);
                            }
                        }
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

        // Also check for existing CSS that might have loaded before this script
        document.addEventListener('DOMContentLoaded', function () {
            var existingLinks = document.querySelectorAll(
                'link[rel="stylesheet"]',
            );
            existingLinks.forEach(function (link) {
                if (link.href && !link.classList.contains('critical-css')) {
                    var isDeferredCSS = deferredCSSPatterns.some((pattern) =>
                        pattern.test(link.href),
                    );
                    if (isDeferredCSS && !link.hasAttribute('data-deferred')) {
                        console.log('Deferring existing CSS:', link.href);
                        deferCSS(link);
                    }
                }
            });
        });
    } catch (e) {
        console.error('CSS Partytown Error:', e);
    }
})();
